(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function loadMorePosts() {
  return {
    loadMoreButton: document.getElementById('load-more-posts'),
    container: document.getElementById('post-feed'),
    loader: document.getElementById('post-loader'),
    init: function init() {
      this.loadMore();
      this.masonry();
      this.categoryToggle();
    },
    loadMore: function loadMore() {
      var that = this;
      var sticky = that.container.getAttribute('data-sticky'),
          catId = that.container.getAttribute('data-cat'),
          keywords = that.container.getAttribute('data-keywords'),
          pages = parseInt(that.container.getAttribute('data-pages')),
          noMoreMessage = '<div class="no-more-message">There are no more posts.</div>';
      var page = parseInt(that.container.getAttribute('data-page')),
          url = '/wp-json/blog/v1/load-more?per_page=12';

      if (catId) {
        url += '&cat=' + catId;
      }

      if (keywords) {
        url += '&keywords=' + keywords;
      }

      if (sticky.length > 0) {
        url += '&sticky=' + sticky;
      } //Check url for pagination during page load


      var hash = window.location.hash;

      if (hash.includes('page') && !isNaN(hash.split('page=')[1])) {
        var _page = parseInt(hash.split('page=')[1]); //Ask what to do here. It doesn't seem right to load all the pages
        // console.log(page);

      } //Load more click event


      if (that.loadMoreButton) {
        that.loadMoreButton.addEventListener('click', function () {
          that.loader.style.display = 'block';
          var offset = 12 * page;
          var ajaxUrl = url + '&offset=' + offset; // console.log(ajaxUrl);

          var xhr = new XMLHttpRequest();

          xhr.onload = function () {
            if (this.readyState == 4 && this.status == 200) {
              var results = JSON.parse(xhr.response);

              if (results) {
                that.container.insertAdjacentHTML('beforeend', results);

                if (page + 1 < pages) {
                  page++;
                  that.container.setAttribute('data-page', page); // window.location.hash = 'page=' + page;
                } else {
                  that.loadMoreButton.style.display = 'none';
                  that.container.insertAdjacentHTML('afterend', noMoreMessage);
                }

                that.masonry();
              } else {
                that.loadMoreButton.style.display = 'none';
                that.container.insertAdjacentHTML('afterend', noMoreMessage);
              }
            }

            that.loader.style.display = 'none';
          };

          xhr.open('GET', ajaxUrl);
          xhr.send();
        });
      }
    },
    masonry: function masonry() {
      var elem = document.getElementById('post-feed');
      var msnry = new Masonry(elem, {
        // options
        itemSelector: '.post-card',
        columnWidth: 400,
        fitWidth: true
      });
    },
    categoryToggle: function categoryToggle() {
      document.getElementById('toggle-categories').addEventListener('click', function () {
        document.getElementById('blog-categories').classList.toggle('active');
      }, false);
    }
  };
}

var blogPage = loadMorePosts();
blogPage.init();

},{}]},{},[1]);
